import { useTheme } from '@emotion/react';
import { Group, Paper, Text, UnstyledButton } from '@mantine/core';
import useTranslation from 'next-translate/useTranslation';
import { IconPlus } from '@tabler/icons-react';

import { getPrimaryThemeColor } from '~/config/themeUtils';
import { Avatar } from '~/domains/common/components/Avatar/Avatar';

type CreatePostRowProps = {
  onClick: VoidFunction;
};

/** @deprecated used by legacy Posts */
function CreatePostRow({ onClick }: CreatePostRowProps) {
  const { t } = useTranslation('commissioner');
  const theme = useTheme();

  return (
    <UnstyledButton onClick={onClick}>
      <Paper p="md">
        <Group>
          <Avatar
            styles={{
              placeholder: { backgroundColor: getPrimaryThemeColor(theme) },
            }}
            radius="xl"
            variant="filled"
          >
            <IconPlus color={theme.black} />
          </Avatar>
          <Text size={16} fw={700}>
            {t('hub.posts.createPostCTA')}
          </Text>
        </Group>
      </Paper>
    </UnstyledButton>
  );
}

export default CreatePostRow;
